import { useNavigate } from 'react-router-dom';
import StagePackageDialog from '../../StagePackageDialog';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { useSsoReauth } from '../../contexts/SsoReauthContext';
import { showToastError } from '../../components/ToastNotifications';
import { getAvailableTags } from '../../hooks/usePackages';
import { usePackagesWizard } from './PackagesWizardContext';

export default function StagePackageContainer() {
  const navigate = useNavigate();
  const { org } = useLegacyAppSession();
  const { handleSsoError } = useSsoReauth();
  const {
    resetStageWizard,
    setStageCandidates,
    setStageSelection,
  } = usePackagesWizard();

  return (
    <StagePackageDialog
      organizationId={Number(org?.id) || undefined}
      onClose={() => {
        resetStageWizard();
        navigate('/packages', { replace: true });
      }}
      onNext={async ({ marketId, facilityId: ridFacilityId, metrcFacilityId, marketName, facilityName }) => {
        if (!org?.id) {
          return;
        }

        try {
          const available = await getAvailableTags({
            organizationId: org.id,
            facilityId: ridFacilityId,
            page: 0,
            pageSize: 500,
          });

          if (available.documents.length) {
            setStageSelection({ marketId, ridFacilityId, marketName, facilityName, metrcFacilityId });
            setStageCandidates(
              available.documents.map((item) => ({
                ...item,
                selected: false,
                marketId,
                ridFacilityId,
              }))
            );
            navigate('/packages/stage/select', { replace: true });
          } else {
            showToastError('No available tags found for this facility');
          }
        } catch (error) {
          console.error(error);
          if (handleSsoError(error, { returnTo: '/packages/stage' })) return;
          showToastError('Error trying to obtain available tags for this facility');
        }
      }}
    />
  );
}
